import script from "./ProdiSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ProdiSelector.vue?vue&type=script&setup=true&lang=js"

import "./ProdiSelector.vue?vue&type=style&index=0&id=5e3c5149&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e3c5149"]])

export default __exports__